import { api } from "./client";

export type SupportSessionStatus =
  | "requested"
  | "awaiting_consent"
  | "active"
  | "ended"
  | "denied"
  | "expired";

export type SupportAuditEvent = {
  id: string;
  session: string;
  event_type: string;
  actor: string | null;
  actor_email: string | null;
  ip: string | null;
  metadata: Record<string, unknown>;
  recorded_at: string;
};

export type SupportSession = {
  id: string;
  tenant_id: string;
  target_agent: string;
  target_agent_label: string;
  target_agent_hostname: string;
  requested_by: string | null;
  requested_by_email: string | null;
  support_user: string | null;
  support_user_email: string | null;
  reason: string;
  status: SupportSessionStatus;
  rustdesk_ticket_hash: string;
  requested_at: string;
  user_consent_at: string | null;
  started_at: string | null;
  ended_at: string | null;
  expires_at: string;
  end_reason: string;
  audit_log?: SupportAuditEvent[];
};

export async function listSupportSessions(): Promise<SupportSession[]> {
  const { data } = await api.get<{ results: SupportSession[] }>("/support/sessions");
  return data.results;
}

export async function createSupportSession(
  target_agent_id: string,
  reason: string,
): Promise<SupportSession> {
  const { data } = await api.post<SupportSession>("/support/sessions", {
    target_agent_id,
    reason,
  });
  return data;
}

export async function getSupportSession(id: string): Promise<SupportSession> {
  const { data } = await api.get<SupportSession>(`/support/sessions/${id}`);
  return data;
}

export async function endSupportSession(id: string): Promise<SupportSession> {
  const { data } = await api.post<SupportSession>(`/support/sessions/${id}/end`);
  return data;
}

export function isOpen(status: SupportSessionStatus): boolean {
  return status === "requested" || status === "awaiting_consent" || status === "active";
}


// ---------------------------------------------------------------------------
// Staff (billing_exempt) endpoints
// ---------------------------------------------------------------------------


export type AdminSupportSession = SupportSession & {
  tenant_name: string;
  rustdesk_ticket: string;
};

export async function listAdminSupportSessions(): Promise<AdminSupportSession[]> {
  const { data } = await api.get<{ results: AdminSupportSession[] }>("/support/admin/sessions");
  return data.results;
}

export async function endAdminSupportSession(id: string): Promise<AdminSupportSession> {
  const { data } = await api.post<AdminSupportSession>(`/support/admin/sessions/${id}/end`);
  return data;
}
